import Store from './store';

const lsStore = Store({
    userData: null,
    wfhSnapshotDownloaded: false,
}, 'user_data_persistence');

export function setUserData (value = null) {
    lsStore.commit('save', {
        key: 'userData',
        value: value,
    });
}

export function getUserData () {
    return lsStore.state.userData;
}

export function setWfhSnapshotDownloaded (value) {
    lsStore.commit('save', {
        key: 'wfhSnapshotDownloaded',
        value: value,
    });
}

export function getWfhSnapshotDownloaded () {
    return lsStore.state.wfhSnapshotDownloaded;
}
